<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="列名" prop="label">
        <el-input v-model="dataForm.label" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="字段名" prop="prop">
        <el-input v-model="dataForm.prop" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="默认列宽" prop="width">
        <el-input v-model="dataForm.width" placeholder="默认列宽"></el-input>
      </el-form-item>
      <el-form-item label="格式化" prop="formatter">
        <el-input v-model="dataForm.formatter" placeholder="格式化"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    tableId: ''
  },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {
        id: '',
        pid: '',
        label: '',
        prop: '',
        width: '',
        formatter: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pid: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], label: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], prop: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], width: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], formatter: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        pid: '', label: '', prop: '', width: '', formatter: ''
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/table/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm,
          pid: this.tableId
        }
        this.$http[!postForm.id ? 'post' : 'put']('/sys/table/', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
